/**
 * Traducciones de mensajes de error de autenticación de Supabase Auth
 * Los mensajes originales vienen en inglés y se traducen al español
 */

const errorTranslations: Record<string, string> = {
  // OAuth / proveedores externos
  "Sign in was cancelled": "Cancelaste el inicio de sesión",
  "Sign in was canceled": "Cancelaste el inicio de sesión",
  "Sign up was cancelled": "Cancelaste el registro",
  "Sign up was canceled": "Cancelaste el registro",
  "was cancelled": "Cancelaste el proceso",
  "was canceled": "Cancelaste el proceso",
  "User cancelled": "Cancelaste el inicio de sesión",
  "User canceled": "Cancelaste el inicio de sesión",
  "popup_closed_by_user": "Cerraste la ventana antes de completar el inicio de sesión",
  "access_denied": "No autorizaste el acceso. Intenta de nuevo",
  "OAuth provider not supported": "Este método de inicio de sesión no está disponible",
  "Unsupported provider": "Este método de inicio de sesión no está disponible",
  "provider is not enabled": "Este método de inicio de sesión no está habilitado",
  "State verification failed":
    "Se interrumpió el inicio de sesión. Volvé a intentarlo desde este mismo navegador",
  "state verification failed":
    "Se interrumpió el inicio de sesión. Volvé a intentarlo desde este mismo navegador",
  "invalid_request":
    "Se interrumpió el inicio de sesión. Volvé a intentarlo desde este mismo navegador",
  "Authorization failed":
    "No se pudo completar el inicio de sesión. Volvé a intentarlo desde este mismo navegador",

  // Errores de login
  "Invalid login credentials": "Email o contraseña incorrectos. Verifica e intenta de nuevo",
  "Invalid email or password": "Email o contraseña incorrectos. Verifica e intenta de nuevo",
  "invalid_credentials": "Email o contraseña incorrectos. Verifica e intenta de nuevo",
  "Email not confirmed": "Debes confirmar tu email antes de iniciar sesión. Revisa tu bandeja de entrada",
  "email_not_confirmed": "Debes confirmar tu email antes de iniciar sesión. Revisa tu bandeja de entrada",
  "Email address not authorized": "Este email no está autorizado para acceder",
  "User not found": "No encontramos una cuenta con ese email",
  "user_not_found": "No encontramos una cuenta con ese email",
  "User is banned": "Esta cuenta está suspendida. Contacta a soporte",
  "user_banned": "Esta cuenta está suspendida. Contacta a soporte",
  "User account is disabled": "Esta cuenta está deshabilitada. Contacta a soporte",
  "account is disabled": "Esta cuenta está deshabilitada. Contacta a soporte",
  "User is locked": "Cuenta bloqueada temporalmente por seguridad. Intenta más tarde",
  "account_locked": "Cuenta bloqueada temporalmente por seguridad. Intenta más tarde",
  "locked": "Cuenta bloqueada temporalmente por seguridad. Intenta más tarde",
  "MFA challenge failed": "Falló la verificación de dos pasos. Intenta de nuevo",
  "mfa_challenge_failed": "Falló la verificación de dos pasos. Intenta de nuevo",
  "captcha verification failed": "No se pudo verificar el captcha. Recarga la página e intenta de nuevo",
  "captcha_failed": "No se pudo verificar el captcha. Recarga la página e intenta de nuevo",

  // Errores de registro
  "User already registered": "Este email ya está registrado. Inicia sesión",
  "A user with this email address has already been registered": "Este email ya está registrado. Inicia sesión",
  "already registered": "Este email ya está registrado. Inicia sesión",
  "already been registered": "Este email ya está registrado. Inicia sesión",
  "user_already_exists": "Este email ya está registrado. Inicia sesión",
  "Signup requires a valid password": "Ingresa una contraseña válida",
  "Signup is disabled": "El registro está deshabilitado temporalmente",
  "Signups not allowed": "El registro no está permitido en este momento",
  "signup_disabled": "El registro está deshabilitado temporalmente",
  "Unable to validate email address": "Email inválido. Verifica el formato",
  "invalid format": "Formato de email inválido",
  "Email address is invalid": "Email inválido. Verifica el formato",
  "Email address \"": "Email inválido. Verifica el formato",
  "is invalid": "Email inválido. Verifica el formato",
  "Database error saving new user": "Error al guardar la cuenta. Intenta de nuevo en unos minutos",
  "Database error": "Error de base de datos. Intenta de nuevo en unos minutos",
  "duplicate key": "Este email ya está registrado. Inicia sesión",
  "violates unique constraint": "Este email ya está registrado. Inicia sesión",
  
  // Errores de contraseña
  "Password should be at least 6 characters": "La contraseña debe tener al menos 6 caracteres",
  "Password should be at least": "La contraseña es muy corta",
  "Password should contain at least one character of each": "La contraseña debe contener mayúsculas, minúsculas y números",
  "Password is too weak": "La contraseña es muy débil. Intenta agregar letras y números",
  "Password is too commonly used or easily guessed": "Esa contraseña es muy común. Intenta cambiar algunos caracteres (ejemplo: agrega un número o símbolo)",
  "password is too commonly used": "Esa contraseña es muy común. Intenta cambiar algunos caracteres",
  "pwned": "Esa contraseña aparece en filtraciones conocidas. Usa una diferente",
  "Password is known to be weak": "Esa contraseña es muy común o apareció en filtraciones. Elige una diferente (combina mayúsculas, números y símbolos)",
  "known to be weak": "Esa contraseña es muy común o apareció en filtraciones. Elige una diferente (combina mayúsculas, números y símbolos)",
  "weak_password": "Esa contraseña es muy débil. Elige una diferente (combina mayúsculas, números y símbolos)",
  "New password should be different from the old password": "La nueva contraseña debe ser diferente a la anterior",
  "Password does not meet": "La contraseña no cumple con los requisitos de seguridad",
  
  // Rate limiting / bloqueos por intentos
  "Email rate limit exceeded": "Enviamos demasiados correos. Espera unos minutos e intenta de nuevo",
  "over_email_send_rate_limit": "Enviamos demasiados correos. Espera unos minutos e intenta de nuevo",
  "over_request_rate_limit": "Demasiados intentos. Espera unos minutos antes de intentar de nuevo",
  "For security purposes, you can only request this after": "Por seguridad, espera unos segundos antes de intentar de nuevo",
  "Too many requests": "Demasiadas solicitudes. Espera un momento e intenta de nuevo",
  "too_many_requests": "Demasiadas solicitudes. Espera un momento e intenta de nuevo",
  "rate limit": "Demasiados intentos. Espera unos minutos antes de intentar de nuevo",
  "Request rate limit reached": "Demasiados intentos. Espera unos minutos antes de intentar de nuevo",

  // Errores de sesión / expiración
  "Session expired": "Tu sesión expiró. Vuelve a iniciar sesión",
  "session_expired": "Tu sesión expiró. Vuelve a iniciar sesión",
  "JWT expired": "Tu sesión expiró. Vuelve a iniciar sesión",
  "jwt expired": "Tu sesión expiró. Vuelve a iniciar sesión",
  "Invalid JWT": "Sesión inválida. Vuelve a iniciar sesión",
  "invalid_jwt": "Sesión inválida. Vuelve a iniciar sesión",
  "Invalid refresh token": "Tu sesión expiró. Vuelve a iniciar sesión",
  "refresh_token_not_found": "Tu sesión expiró. Vuelve a iniciar sesión",
  "Refresh Token Not Found": "Tu sesión expiró. Vuelve a iniciar sesión",
  "Auth session missing": "No hay una sesión activa. Inicia sesión de nuevo",
  "session_not_found": "No hay una sesión activa. Inicia sesión de nuevo",
  "No user found": "No hay una sesión activa. Inicia sesión de nuevo",
  "Not authenticated": "Debes iniciar sesión para continuar",
  "not_authenticated": "Debes iniciar sesión para continuar",
  "Unauthorized": "No tienes autorización para hacer esto",
  "unauthorized": "No tienes autorización para hacer esto",
  "No autorizado": "No tienes autorización para hacer esto",

  // Errores de email
  "Email link is invalid or has expired": "El enlace expiró o es inválido. Solicita uno nuevo",
  "Token has expired or is invalid": "El enlace expiró o es inválido. Solicita uno nuevo",
  "otp_expired": "El código expiró. Solicita uno nuevo",
  "Token has expired": "El enlace expiró. Solicita uno nuevo",
  "Email not allowed": "Este email no está permitido",
  "Invalid token": "Código o enlace inválido. Solicita uno nuevo",
  "invalid_token": "Código o enlace inválido. Solicita uno nuevo",
  
  // Red / genéricos
  "Failed to fetch": "Error de conexión. Revisa tu internet e intenta de nuevo",
  "Network request failed": "Error de conexión. Revisa tu internet e intenta de nuevo",
  "NetworkError": "Error de conexión. Revisa tu internet e intenta de nuevo",
  "timeout": "La solicitud tardó demasiado. Intenta de nuevo",
  "timed out": "La solicitud tardó demasiado. Intenta de nuevo",
  "fetch failed": "Error de conexión. Revisa tu internet e intenta de nuevo",
  "Internal Server Error": "Error del servidor. Intenta de nuevo en unos minutos",
  "Service Unavailable": "Servicio no disponible. Intenta de nuevo en unos minutos",
};

/**
 * Traduce un mensaje de error de autenticación al español
 * @param message - Mensaje de error original (en inglés)
 * @returns Mensaje traducido al español o el original si no hay traducción
 */
export const translateAuthError = (message: string): string => {
  if (!message) return "Error desconocido";
  
  // Buscar coincidencia exacta
  if (errorTranslations[message]) {
    return errorTranslations[message];
  }
  
  // Buscar coincidencia parcial (para mensajes que incluyen datos dinámicos)
  for (const [key, translation] of Object.entries(errorTranslations)) {
    if (message.toLowerCase().includes(key.toLowerCase())) {
      return translation;
    }
  }
  
  // Si no hay traducción, retornar mensaje original
  return message;
};
